import { FC } from 'react';

import { InfoCircle, XCloseIcon } from '../../../../assets/icons/index';
import { InfoCircleVariant } from '../../../../assets/icons/info-circle';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useLocale } from '../../../../hooks/index';

export type WorkspaceInactiveRoomBannerProps = {
  /** False for a viewer the page hides the link from — an Auditor. */
  canReactivate: boolean;
  isReactivating: boolean;
  onDismiss: () => void;
  onReactivate: () => void;
};

export const WorkspaceInactiveRoomBanner: FC<WorkspaceInactiveRoomBannerProps> = ({
  canReactivate,
  isReactivating,
  onDismiss,
  onReactivate,
}) => {
  const { messagesLocale } = useLocale();

  return (
    <div className="flex items-center gap-2 rounded-md bg-sunbeam-50 px-4 py-3" role="status">
      <InfoCircle height={16} variant={InfoCircleVariant.WARNING} width={16} />
      <p className="min-w-0 flex-1 text-xs font-[450] text-gray-800">
        {/* Its own sentence where the link is not there to be hidden: the page drops the button
            for an Auditor, and the sentence it was the subject of ends "…to resume tracking."
            with nothing in front of it. */}
        <AppFormattedMessage
          id={canReactivate ? 'DATA_ROOM_INACTIVE_BANNER' : 'DATA_ROOM_INACTIVE_BANNER_READ_ONLY'}
          values={{
            link: (chunks) => (
              <button
                className="text-brand-700 underline disabled:cursor-default disabled:opacity-60"
                data-permission-required
                disabled={isReactivating}
                onClick={onReactivate}
                type="button"
              >
                {chunks}
              </button>
            ),
          }}
        />
      </p>
      <button aria-label={messagesLocale['CLOSE']} onClick={onDismiss} type="button">
        <XCloseIcon />
      </button>
    </div>
  );
};
